import { render, staticRenderFns } from "./PasswordSetup.vue?vue&type=template&id=a80ae8a4&scoped=true&"
import script from "./PasswordSetup.vue?vue&type=script&lang=js&"
export * from "./PasswordSetup.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSetup.vue?vue&type=style&index=0&id=a80ae8a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ae8a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a80ae8a4')) {
      api.createRecord('a80ae8a4', component.options)
    } else {
      api.reload('a80ae8a4', component.options)
    }
    module.hot.accept("./PasswordSetup.vue?vue&type=template&id=a80ae8a4&scoped=true&", function () {
      api.rerender('a80ae8a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PasswordSetup.vue"
export default component.exports